import { connect } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import PropertySwitch from './components/PropertySwitch';
import BaseFeature from './BaseFeature';
import { PWM_DIM_MODE } from '../../../../../../utils/constantFeatures';
import PropertyDropdown from './components/PropertyDropdown';

class PwmDimMode extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            // autoDetectionState: (this.props.properties[REPEATER.physMinLevel].value === "Off") ? true : false,
            // modeSettingsEnabled: this.props.properties[REPEATER.enableModeSettings].value === 1 ? true : false
        };

        this.handleChange = this.handleChange.bind(this);

    }

    handleChange(propertyName, value) {
        const v = value;
        const newState = {[propertyName]:value};

        this.setState(newState);

        const state = { ...this.state, ...newState };

        this.props.handleChange(propertyName, v);
    }

    render() {
        return (
            <><Row>
                <Col sm={4}>
                    <Card className="card-feature-component" style={{ width: '100%'}}>
                        <div className="card-header-feature">
                            {'PWM Dimming Mode'}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >

                            <PropertySwitch
                                property={this.props.properties[PWM_DIM_MODE.enable]}
                                title={this.props.properties[PWM_DIM_MODE.enable].info.displayName}
                                handleChange={this.handleChange} />

                            <PropertyDropdown
                                property={this.props.properties[PWM_DIM_MODE.type]}
                                properties={this.props.properties[PWM_DIM_MODE.type].valueMeta.availableValues}
                                title={this.props.properties[PWM_DIM_MODE.type].info.displayName}
                                disabled={this.props.properties[PWM_DIM_MODE.enable].value === '0'}
                                measureUnit={''}
                                step={1}
                                handleChange={this.handleChange}
                                dropdownStyle={{padding: '0px', display: 'flex', justifyContent: 'flex-end'}}
                                titleSize={6}
                                dropdownSize={6} />

                        </Card.Body>
                    </Card>
                </Col>
            </Row></>
        );
    }

}

export default connect(
    // mapStateToProps,
    // mapDispatchToProps
)(PwmDimMode);
